let debugTextTranslation_Intervals: any = 0;

export let missingTexts = new Set<string>();

export function debugTextTranslationIsRunning(): boolean {
  return debugTextTranslation_Intervals;
}

export function startDebugTextTranslation() {
  if (debugTextTranslationIsRunning()) {
    return;
  }

  debugTextTranslation_Intervals = setInterval(() => {
    executedDebugTextTranslation();
  }, 2000);
}

export function stopDebugTextTranslation() {
  if (debugTextTranslation_Intervals) {
    clearInterval(debugTextTranslation_Intervals);
    debugTextTranslation_Intervals = 0;
  }
}

function splitTranslationsIntoSpans(t: string, elm: HTMLElement) {
  while (true) {
    let a = t.indexOf("{[");
    let e = t.indexOf("]}");

    if (a >= 0) {
      if (a > 0) {
        const t1 = t.substring(0, a);

        const span = document.createElement("SPAN");
        span.setAttribute("data-noitx", "true");
        span.style.backgroundColor = "#f004"; // red
        span.textContent = t;
        elm.appendChild(span);
      }

      let t2 = t.substring(a + 2, e);

      let color = "#0f04"; // green

      if (t2.substring(0, 1) == "!") {
        //
        // Content Text - need no translation
        //
        t2 = t2.substring(1, t2.length - 1);
        color = "#00f1"; // very light blue  // no itx
      }

      if (t2.substring(0, 1) == "?") {
        //
        // key exists. Entry in translation tabel missing
        //
        t2 = t2.substring(1, t2.length - 1);
        color = "#f8f4"; // ligt red  // no itx
      }

      const span = document.createElement("SPAN");
      span.setAttribute("data-noitx", "true");
      span.style.backgroundColor = color;
      span.textContent = t2;
      elm.appendChild(span);

      t = t.substring(e + 2);
    } else {
      const noitx = elm.attributes.getNamedItem("data-noitx") != undefined;

      const span = document.createElement("SPAN");
      span.setAttribute("data-noitx", "true");
      if (!noitx) {
        span.style.backgroundColor = "#f004"; // red
        missingTexts.add(`${state.settings.language}- ${t}`);
      }
      span.textContent = t;
      elm.appendChild(span);
      return;
    }
  }
}

const usedTags = ["DIV", "LI", "A", "BUTTON", "OPTION", "H1", "H2", "H3", "LABEL", "SPAN", "TD", "SELECT"];

function executedDebugTextTranslation() {
  document.querySelectorAll("*").forEach((elm) => {
    if (
      usedTags.includes(elm.tagName) &&
      (elm.tagName != "SPAN" || elm.attributes.getNamedItem("data-noitx") == undefined)
    ) {
      if (elm.childNodes) {
        for (var j = 0; j < elm.childNodes.length; j++)
          if (elm.childNodes[j].nodeType === Node.TEXT_NODE) {
            const t = elm.childNodes[j].textContent;

            if (t) {
              if (t != "") {
                elm.childNodes[j].textContent = "";
                splitTranslationsIntoSpans(t, elm as HTMLElement);
              }
            }
          }
      }
    }
  });
}
